import "../../styles/forms.css";

function getInitials(user) {
    const nombres = user?.nombres || "";
    const apellidos = user?.apellidos || "";

    const n = nombres.trim().charAt(0).toUpperCase();
    const a = apellidos.trim().charAt(0).toUpperCase();

    return `${n}${a}`.trim() || "U";
}

export default function ProfileCard({ user }) {
    if (!user) return null;

    const fullName = `${user.nombres || ""} ${user.apellidos || ""}`.trim();

    return (
        <div className="profile-card">
            <div className="profile-card-avatar-wrap">
                {user.avatarUrl ? (
                    <img
                        src={user.avatarUrl}
                        alt={fullName || "Usuario"}
                        className="profile-card-avatar"
                    />
                ) : (
                    <div className="profile-card-avatar-fallback">
                        {getInitials(user)}
                    </div>
                )}
            </div>

            <div className="profile-card-info">
                <h3>{fullName || "Usuario"}</h3>
                <p>{user.email || "-"}</p>
                <span className="profile-card-role">{user.rol || "USER"}</span>
            </div>
        </div>
    );
}